import { AnalyticsTypes } from '../..'

export namespace Analytics {
    export interface MetricDelta<T> {
        value: T
        delta: number
        increase: boolean
        deltaIsInfinite: boolean
        formattedDeltaValue?: string
        deltaRaw?: number
    }

    export interface SessionMetrics {
        totalUsers: MetricDelta<number>
        newUsers: MetricDelta<number>
        bounceRate: MetricDelta<number>
        averageSessionDuration: MetricDelta<string>
        screenPageViewsPerSession: MetricDelta<number>
    }

    export interface SourceMediumUserRanking {
        topSourceMediums: { sourceMedium: string; users: number }[]
        googleAdsRanking: { position: number; users: number }
    }

    export interface SlideData {
        sessionMetrics: SessionMetrics
        googleAdsSessionMetrics: SessionMetrics
        googleAdsUserRatioDelta: MetricDelta<number>
        sourceMediumUserRanking: SourceMediumUserRanking
    }

    export interface Slide {
        profile?: AnalyticsTypes.SavedAccountIdsLegacy
        data?: SlideData
    }

    export enum Error {
        GENERIC = 'Error occured while generating google analytics report',
        INSUFFICIENT_DATA = 'Insufficient data for reporting period',
        NO_USER_GROUP_FOUND = 'Could not find groupId for given userId',
    }
}
